import Vue from 'vue'
import App from './App.vue'
import router from './router'
import wayCode from './utils/wayCode';
import config from './config'
import ConfirmModal from './components/ConfirmModal.vue'
import 'amfe-flexible'
Vue.config.productionTip = false

// 微信开放标签为自定义标签，忽略 Vue 的未知元素警告
Vue.config.ignoredElements = [...(Vue.config.ignoredElements || []), 'wx-open-launch-weapp']

// 全局注册确认弹框组件（替代浏览器原生 alert，不显示网址）
Vue.component('ConfirmModal', ConfirmModal)
// 同时挂载到原型，方便通过 this.$confirm 调用
Vue.prototype.$confirm = function(options = {}) {
  const defaultConfirm = new Vue(ConfirmModal).$mount()
  document.body.appendChild(defaultConfirm.$el)
  defaultConfirm.show({
    ...options,
    onOk: () => {
      if (options.onOk) options.onOk()
      setTimeout(() => defaultConfirm.$destroy(), 100)
    },
    onCancel: () => {
      if (options.onCancel) options.onCancel()
      setTimeout(() => defaultConfirm.$destroy(), 100)
    }
  })
}

/**
 * 路由守卫
 *
 * @author terrfly
 * @site https://www.techpayx.vip
 * @date 2021/5/8 07:18
 */
router.beforeEach((to, from, next) => {

    console.log("进入路由守卫2", from, to)

    // from: 当前导航正要离开的路由
    // to: 即将要进入的目标路由对象

    // 如果在免登录页面则直接放行
    if (config.passGuardRouteList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
      console.log("路由守卫通过2");
      return false
    }

    //获取不到参数
    let token = to.params[config.urlTokenName] || to.query[config.urlTokenName];
    // let token = 'test';  // 不提交
    if(token){  //放置token信息
        config.cacheToken = token;
    }
    if(!config.cacheToken) {
        next({ name: config.errorPageRouteName, params: { errInfo: "请通过二维码进入支付页面！" } })
        return false;
    }

    //获取不到支付类型, 需要跳转到错误页面
    if(!wayCode.getPayWay()) {
        next({name: config.errorPageRouteName, params: {errInfo: "不支持的支付方式！ 请在微信/支付宝/银联应用内扫码进入！"}})
        return false;
    }
    console.log("路由守卫通过");
    next()
})


Vue.prototype.$config = config;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
